export const STOPPED = 'STOPPED';
export const LOADING = 'LOADING';
export const LOADED = 'LOADED';
export const PLAYING = 'PLAYING';
export const PAUSED = 'PAUSED';
export const ENDED = 'ENDED';
export const ERROR = 'ERROR';
